import { useEffect, useState } from "react";
import CustomButton from "../../../../../components/custom/button";
import CustomInput from "../../../../../components/custom/input";
import BookmarkAddedIcon from "@mui/icons-material/BookmarkAdded";
import { AddressValidation } from "./AddressValidation";
import { showSnackbar } from "../../../../../../app/slices/common/customSnackBar/customSnackbarSlice";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../../app/redux/hooks";
import { AddressValues } from "../ProfilePageTypes";
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { GoogleMapSelector } from "./GoogleMapSelector";
import {
  addAddressAsync,
  getAddressDetailsAsync,
  getAddressListAsync,
} from "../../../../../../app/slices/addressSlice/ProfileSlice";
import AddOrEditAddressSkeleton from "../../skelitons/AddOrEditAddressSkeleton";
import SearchAutoComplete from "./LocationSearchAutocomplete";
import { setCheckoutAddressId } from "../../../../../../app/slices/common/locationSlice/locationSlice";

export const AddOrEditAddress = ({ modalClose, modalType, addressId }: any) => {
  const dispatch = useAppDispatch();
  const initialState: AddressValues = {
    // completeAddress: "",
    // locality: "",
    address_type: "other",
    landmark: "",
    flat_no: "",
    // is_default: false,
  };
  const { addAddressloader, addressDetailLoader } = useAppSelector(
    (state) => state.AddressState
  );
  const [selectedLocation, setSelectedLocation] = useState<
    google.maps.LatLngLiteral | undefined
  >(undefined);
  const [selectedLocationOnEdit, setSelectedLocationOnEdit] = useState<
    google.maps.LatLngLiteral | undefined
  >(undefined);
  const [selectedActualAddress, setSelectedActualAddress] = useState("");
  const [addressData, setAddressData] = useState(initialState);

  const [errors, setErrors] = useState<Partial<AddressValues>>({});

  // const [buttonConfirm, setButtonConfirm] = useState("confirm");
  // Fetch address details when in edit mode
  useEffect(() => {
    if (modalType === "edit") {
      dispatch(getAddressDetailsAsync(addressId)).then((response: any) => {
        const address = response?.payload?.data?.data;

        if (address) {
          setAddressData({
            address_type: address.address_type || "home",
            landmark: address.landmark || "",
            flat_no: address.flat_no || "",
            // is_default: address.is_default || false,
          });
          setSelectedLocation({
            lat: Number(address.latitude),
            lng: Number(address.longitude),
          });
          setSelectedLocationOnEdit({
            lat: Number(address.latitude),
            lng: Number(address.longitude),
          });
          // setSelectedActualAddress(address.completeAddress || "");
        }
      });
    }
  }, [addressId, dispatch]);
  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;

    let curErrors: any = { ...errors };
    delete curErrors["address_type"];
    setErrors(curErrors);
    setAddressData({
      ...addressData,
      address_type: value,
    });
  };
  const inputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    let curErrors: any = { ...errors };
    delete curErrors[name];
    setErrors(curErrors);
    setAddressData({
      ...addressData,
      [name]: value,
    });
  };
  const saveDetails = () => {
    const errorCheck = AddressValidation(addressData);
    if (Object.keys(errorCheck).length === 0) {
      let payload: any = {
        ...addressData,
        latitude: selectedLocation?.lat?.toFixed(4),
        longitude: selectedLocation?.lng?.toFixed(4),
        // is_default: addressData?.is_default,
      };

      dispatch(addAddressAsync({ payload, modalType, addressId }))
        .then((response: any) => {
          if (
            response?.payload?.status === 200 ||
            response?.payload?.status === 201
          ) {
            dispatch(setCheckoutAddressId(response.payload.data.data.id));
            dispatch(
              showSnackbar({
                message: `Address ${
                  modalType === "edit" ? "updated" : "added"
                } successfuly.`,
                severity: "success",
                autoHide: 2000,
              })
            );
            setAddressData(initialState);
            modalClose();
            dispatch(getAddressListAsync());
          } else {
            dispatch(
              showSnackbar({
                message: "Somthing went wrong, Please try again later.",
                severity: "error",
                autoHide: 2000,
              })
            );
          }
        })
        .catch((err) => {
          dispatch(
            showSnackbar({
              message: "Somthing went wrong, Please try again later.",
              severity: "error",
              autoHide: 2000,
            })
          );
        });
      // dispatch(
      //   showSnackbar({
      //     message: "validation done",
      //     severity: "success",
      //     autoHide: 2000,
      //   })
      // );
    } else {
      setErrors(errorCheck);
    }
  };
  return (
    <>
      {modalType === "edit" && addressDetailLoader ? (
        <AddOrEditAddressSkeleton />
      ) : (
        <>
          <GoogleMapSelector
            setSelectedLocation={setSelectedLocation}
            setSelectedLocationOnEdit={setSelectedLocationOnEdit}
            selectedLocation={selectedLocation}
            selectedLocationOnEdit={selectedLocationOnEdit}
            setSelectedActualAddress={setSelectedActualAddress}
            modalType={modalType}
          />
          {/* {selectedLocation && ( */}
          <div style={{ marginTop: "20px" }}>
            <div className="row">
              {/* <div className="col-md-12">
                  <CustomInput
                    label="DELIVERY AREA"
                    fullWidth
                    value={selectedActualAddress}
                  />
                </div> */}
              <div className="col-md-12 mt-3">
                <SearchAutoComplete
                  selectedActualAddress={selectedActualAddress}
                  setSelectedActualAddress={setSelectedActualAddress}
                  setSelectedLocation={setSelectedLocation}
                />
              </div>

              {/* {buttonConfirm === "save" ? ( */}
              <>
                <div className="col-md-12 mt-3">
                  <CustomInput
                    onChange={inputChange}
                    name="flat_no"
                    label="Door/Flat No"
                    value={addressData?.flat_no}
                    fullWidth
                    error={!!errors?.flat_no}
                    helperText={errors?.flat_no}
                  />
                </div>
                <div className="col-md-12 mt-3">
                  <CustomInput
                    name="landmark"
                    label="Landmark"
                    value={addressData?.landmark}
                    onChange={inputChange}
                    fullWidth
                    error={!!errors?.landmark}
                    helperText={errors?.landmark}
                  />
                </div>
                {/* <div className="col-md-12 mt-3">
                  <CustomInput
                    label="Area/Sector/Locality"
                    name="locality"
                    fullWidth
                    onChange={inputChange}
                    variant="outlined"
                    required
                    error={!!errors?.locality}
                    helperText={errors?.locality}
                  />
                </div>
                <div className="col-md-12 mt-3">
                  <CustomInput
                    label="Complete Address"
                    fullWidth
                    name="completeAddress"
                    onChange={inputChange}
                    variant="outlined"
                    required
                    multiline
                    rows={3}
                    error={!!errors?.completeAddress}
                    helperText={errors?.completeAddress}
                  />
                </div> */}
                {/* <div className="col-md-12 mt-3">
                  <FormControlLabel
                    control={<Checkbox size="small" />}
                    label="Would you like to set this as your default address?"
                  />
                </div> */}
                <div
                  className="col-md-12 mt-3"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <FormControl>
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                      value={addressData?.address_type}
                      onChange={handleRadioChange}
                    >
                      <FormControlLabel
                        value="home"
                        control={<Radio />}
                        label="Home"
                      />
                      <FormControlLabel
                        value="work"
                        control={<Radio />}
                        label="Work"
                      />
                      <FormControlLabel
                        value="other"
                        control={<Radio />}
                        label="Other"
                      />
                    </RadioGroup>
                  </FormControl>
                </div>
              </>
              {/* ) : (
              ""
            )} */}
              {/* <div className="col-md-6 mt-2"></div> */}
              <div className="col-md-12 mt-2">
                {/* {buttonConfirm === "confirm" ? (
                <CustomButton
                  endIcon={<ArrowForwardIcon />}
                  size="large"
                  name="Confirm and Proceed"
                  fullWidth
                  onClick={() => setButtonConfirm("save")}
                />
              ) : ( */}
                <CustomButton
                  endIcon={<BookmarkAddedIcon />}
                  size="large"
                  name="Save address and proceed"
                  fullWidth
                  loader={addAddressloader}
                  onClick={saveDetails}
                />
                {/* )} */}
              </div>
            </div>
          </div>
          {/* )} */}
        </>
      )}
    </>
  );
};
